var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRebuild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_31525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1642 6.48083C18.0208 5.88249 17.265 5.68166 16.83 6.11666C15.7842 7.16249 14.6192 8.32749 14.39 8.55666C13.5267 9.41999 12.0925 9.3675 11.2992 8.39666C10.6092 7.55333 10.7567 6.29666 11.5275 5.52583L13.8825 3.17082C14.3175 2.73582 14.1175 1.97916 13.5192 1.83582C12.6475 1.62666 11.705 1.60166 10.7283 1.81332C8.3025 2.33999 6.36917 4.32666 5.935 6.77083C5.74 7.86916 5.83417 8.92666 6.15083 9.88249L2.49083 13.5317C1.3925 14.63 1.3925 16.4108 2.49083 17.5092C3.58917 18.6075 5.37 18.6075 6.46833 17.5092L10.1333 13.855C11.085 14.1675 12.1367 14.2583 13.2283 14.0642C15.6733 13.63 17.66 11.6975 18.1858 9.27083C18.3983 8.29416 18.3725 7.35249 18.1642 6.48083Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58334 16.6667C5.2737 16.6667 5.83334 16.1071 5.83334 15.4167C5.83334 14.7264 5.2737 14.1667 4.58334 14.1667C3.89299 14.1667 3.33334 14.7264 3.33334 15.4167C3.33334 16.1071 3.89299 16.6667 4.58334 16.6667Z",
    fill: "#6C6C6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_31525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebuild);
export default __webpack_public_path__ + "static/media/rebuild.cc283553681983cef5d83a7db7c6833f.svg";
export { ForwardRef as ReactComponent };